import {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";


const Listing = () => {
    const searchColumn = 'name'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())


    const fetchEntities = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut("/journeys/get",
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };


    useEffect(() => {
        fetchEntities().then((entities) => {
            setEntities(entities);
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete("/journeys/delete",
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );
        }
    };



    const handleDuplicate = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete("/journeys/duplicate",
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );
        }
    }



    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Title", prop: "title", size: 25, output: (entity) => {
                    return <Link to={`/journeys/${entity?._id?.$oid}`}>
                        <strong>{entity?.title}</strong>
                    </Link>;
                }
            },
            {
                label: "Audience", prop: "audience", output: (entity) => {
                    return entity?.Audience?.name
                }
            },
            {
                label: "Enterprise", prop: "enterprise", output: (entity) => {
                    return entity?.Audience?.Enterprise?.name
                }
            },
            {
                label: "Status", prop: "status", output: (entity) => {
                    return entity?.status
                }
            },
            {
                label: "Daily sms limit", size: 25, prop: "daily_sms_limit", output: (entity) => {
                    return entity?.limits?.daily_sms_limit ? entity.limits.daily_sms_limit :
                        <span className="text-muted">Not configured</span>
                }
            },
            {
                label: "Daily emails limit", size: 25, prop: "daily_email_limit", output: (entity) => {
                    return entity?.limits?.daily_email_limit ? entity.limits.daily_email_limit :
                        <span className="text-muted">Not configured</span>
                }
            },
            {
                label: "Daily ws limit", size: 25, prop: "daily_ws_limit", output: (entity) => {
                    return entity?.limits?.daily_ws_limit ? entity.limits.daily_ws_limit :
                        <span className="text-muted">Not configured</span>
                }
            },
            {
                label: "Frequency", size: 25, prop: "frequency", output: (entity) => {
                    return entity?.schedule?.frequency ? entity?.schedule?.frequency :
                        <span className="text-muted">Not configured</span>
                }
            },
            {
                label: "Start Time", size: 25, prop: "start_time", output: (entity) => {
                    return entity?.schedule?.start_time ? entity?.schedule?.start_time :
                        <span className="text-muted">Not configured</span>
                }
            },
            {
                label: "Start date", size: 25, prop: "start_date", output: (entity) => {
                    if (entity?.schedule?.start_date) {
                        const datetime = new Date(entity?.schedule?.start_date);
                        return datetime.toLocaleString()
                    } else {
                        return <span className="text-muted">Not configured</span>
                    }
                }
            },
            {
                label: "End date", size: 25, prop: "end_date", output: (entity) => {
                    if (entity?.schedule?.start_date) {
                        const datetime = new Date(entity?.schedule?.end_date);
                        return datetime.toLocaleString()
                    } else {
                        return <span className="text-muted">Not configured</span>
                    }
                }
            },
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)},
            /*{value: "duplicate", label: "Duplicate", action: (selected) => handleDuplicate(selected)}*/
        ],
        edit          : {
            path : `/journeys/:id`,
            label: "Edit journey",
            icon : "edit"
        }
    };


    return (
        <>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Listing;